<template>
  <div>
    <b-row class="mb-0">
      <div class="col">
        <p class="mb-0">
          <strong>ACUERDOS DE PAGO Y ABONOS</strong>
        </p>
      </div>

      <div class="col-sm-4 text-right">
        <b-dropdown
          text="Nuevo Abono/Acuerdo"
          size="sm"
          class="btn b-dropdown text-right"
          variant="success"
          v-if="CREATE"
        >
          <b-dropdown-item @click="addPayment(_type.ABONO)" :disabled="closed_debt">Abono</b-dropdown-item>
          <b-dropdown-item
            @click="addPayment(_type.ACUERDO_SIMPLE)"
            :disabled="closed_debt"
          >Acuerdo - Sencillo</b-dropdown-item>
          <b-dropdown-item
            @click="addPayment(_type.ACUERDO_PROGRAMADO)"
            :disabled="closed_debt"
          >Acuerdo - Programado</b-dropdown-item>
        </b-dropdown>
      </div>
    </b-row>

    <hr class="p-0 mt-0" />

    <section class="proj-page-section comments">
      <section class="without" v-if="!lstPayments.length > 0" style="margin-top:0px">
        <div class="row">
          <figure class="text-center">
            <img src="img/sin_gestion.png" alt width="210px" />
          </figure>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Oops!</h1>
            <h4>
              No hay Acuerdos o Abonos
              <br />en este deudor.
            </h4>
          </div>
        </div>
      </section>

      <div class="comments" v-if="READ && lstPayments.length > 0">
        <section
          class="box-typical comment box-typical-custom"
          v-for="item in lstPayments"
          :key="item.id"
        >
          <div class="row">
            <div class="col-sm-2 mr-0">
              <div class="row">
                <div class="col-md-12 text-center">
                  <strong>
                    <p class="mb-2">CREADA POR</p>
                  </strong>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center">
                  <img
                    v-if="item.user_image === null"
                    src="img/avatars/avatar-2-64.png"
                    class="rounded-circle"
                  />
                  <img v-else :src="item.user_image" class="rounded-circle img-gestion" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center mt-2">
                  <p>{{item.user_name}}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-10">
              <div class="row">
                <div class="col-sm-9"></div>
                <div class="col-sm-3 text-right mb-2 pr-0">
                  <b-button
                    size="sm"
                    variant="info"
                    class="mr-1"
                    title="Editar"
                    @click="editPayment(item)"
                    :disabled="closed_debt"
                    v-if="UPDATE"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>

                  <b-button
                    size="sm"
                    variant="danger"
                    title="Eliminar"
                    @click="deletePayment(item)"
                    :disabled="closed_debt"
                    v-if="DELETE"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <p class="mb-1">
                    <strong>TIPO</strong>
                  </p>
                  <p>{{item.type_name}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>FECHA</strong>
                  </p>
                  <p>{{formatDate(item.date)}}</p>
                </div>
                <div class="col">
                  <p class="mb-1">
                    <strong>VALOR (COP)</strong>
                  </p>
                  <p class="custom-select-trebol-primary pl-2">$ {{formatPrice(item.value)}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>DESTINO</strong>
                  </p>
                  <p>{{item.paid_to_name}}</p>
                </div>

                <div class="col">
                  <p class="mb-1">
                    <strong>ESTADO</strong>
                  </p>
                  <p
                    :class="item.status == 'P' ? 'text-warning' : item.status == 'F' ? 'text-success' : 'text-danger'"
                  >{{item.status_name}}</p>
                </div>
              </div>
              <hr />

              <div class="row" v-if="currency">
                <div class="col">
                  <p class="mb-1">
                    <strong>VALOR ({{currency.name}})</strong>
                  </p>
                  <p>$ {{formatPrice(item.currency_value)}}</p>
                </div>
              </div>

              <hr />

              <div class="row">
                <div class="col-12">
                  <p class="mb-1">
                    <strong>COMENTARIO</strong>
                  </p>
                  <p>{{item.observation}}</p>
                </div>
              </div>

              <div class="row row-footer" v-if="role_id != 6">
                <div class="w100 text-right mr-2 mt-2">
                  <p>
                    <i class="fa fa-clock-o"></i>
                    Creado el &nbsp;{{item.created_at}}
                    <i
                      class="fa fa-clock-o ml-2"
                    ></i>
                    Actualizado el &nbsp;{{item.updated_at}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <pagination
          class="mb-0"
          :data="laravelData"
          @pagination-change-page="getPayments"
          :limit="limit"
          :show-disabled="showDisabled"
          :size="size"
          :align="align"
        >
          <span slot="prev-nav">Anterior</span>
          <span slot="next-nav">Siguiente</span>
        </pagination>
      </div>
    </section>

    <!-- MODAL PARA LOS CONRATOS -->
    <div class="modal fade" id="dlgPayment">
      <div class="modal-dialog modal-dialog-centered modal-success">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header m-0 p-2">
            <h6 class="modal-title">{{title}}</h6>
            <button type="button" class="close" @click="closePayment()">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form
              @submit.prevent="savePayment()"
              method="post"
              v-if="payment.debtor_id"
              enctype="multipart/form-data"
            >
              <b-row>
                <b-col cols="11" sm="11" class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="danger">
                        <b>Por favor corrige los siguientes errores:</b>
                        <ul>
                          <li v-for="(error, index) in errores" :key="index">{{ error }}</li>
                        </ul>
                      </b-alert>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbType">Tipo</label>
                        <b-form-select v-model="payment.type" id="cmbType" :disabled="true">
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option value="AC">Acuerdo</option>
                          <option value="AB">Abono</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbEstado">Estado</label>
                        <b-form-select
                          v-model="payment.status"
                          id="cmbEstado"
                          :disabled="disabled || disabled_status"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option value="P">Programado</option>
                          <option value="F">Pagado</option>
                          <option value="V">Vencido</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="type_select == _type_aux.ACUERDO_PROGRAMADO">
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txt_start_date">Fecha desde</label>
                        <b-form-input
                          type="date"
                          id="txt_start_date"
                          v-model="payment.start_date"
                          :min="minDate"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txt_end_date">Fecha hasta</label>
                        <b-form-input
                          type="date"
                          id="txt_end_date"
                          v-model="payment.end_date"
                          :min="minDate"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6" v-if="type_select != _type_aux.ACUERDO_PROGRAMADO">
                      <b-form-group>
                        <label for="txtFecha">Fecha</label>
                        <b-form-input
                          type="date"
                          id="txtFecha"
                          v-model="payment.date"
                          :disabled="disabled"
                          :min="minDate"
                          :max="maxDate"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6" v-if="type_select == _type_aux.ACUERDO_PROGRAMADO">
                      <b-form-group>
                        <label for="txtCurrency">Divisa</label>
                        <b-form-input
                          id="txtCurrency"
                          v-model="currency.name"
                          type="text"
                          :disabled="true"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6" v-if="type_select == _type_aux.ACUERDO_PROGRAMADO">


                      <b-form-group>
                        <label for="txtValor">Valor</label>
                        <b-form-input
                          type="number"
                          id="txtValor"
                          v-model="payment.currency_value"
                          :disabled="disabled"
                          @change="calculateCurrency()"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbDestino">Destino</label>
                        <b-form-select
                          v-model="payment.paid_to"
                          id="cmbDestino"
                          :disabled="disabled"
                        >
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>

                          <option
                            v-for="item in lstPaidTo"
                            :key="item.id"
                            :value="item.id"
                          >{{ item.name }}</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6" v-if="type_select == _type_aux.ACUERDO_PROGRAMADO">
                      <b-form-group>
                        <label for="cmbCiclo">Ciclo</label>
                        <b-form-select v-model="payment.loop" id="cmbCiclo">
                          <template slot="first">
                            <option :value="null" disabled>-- Seleccione --</option>
                          </template>
                          <option value="S">Semanal</option>
                          <option value="Q">Quincenal</option>
                          <option value="M">Mensual</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="type_select != _type_aux.ACUERDO_PROGRAMADO">
                    <b-col>
                      <b-form-group>
                        <label for="txtCurrency">Divisa</label>
                        <b-form-input
                          id="txtCurrency"
                          v-model="currency.name"
                          type="text"
                          :disabled="true"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtValor">Valor</label>
                        <b-form-input
                          type="number"
                          id="txtValor"
                          v-model="payment.currency_value"
                          :disabled="disabled"
                          @change="calculateCurrency()"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row >
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtValorCop">Valor (COP)</label>
                        <b-form-input
                          type="text"
                          id="txtValorCop"
                          v-model="payment.value"
                          :disabled="true"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col sm="12">
                      <b-form-group>
                        <label for="txtComentario">Comentario</label>
                        <b-form-textarea
                          rows="4"
                          id="txtComentario"
                          no-resize
                          v-model="payment.observation"
                          :disabled="disabled"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!disabled">
                    <b-col sm="6" class="center-block">
                      <b-row>
                        <b-col sm="6">
                          <b-button
                            type="submit"
                            variant="success"
                            class="btn-sm col-sm-12"
                            :disabled="disabled"
                          >GUARDAR</b-button>
                        </b-col>

                        <b-col sm="6">
                          <b-button
                            type="button"
                            variant="danger"
                            class="btn-sm col-sm-12"
                            @click="closePayment()"
                          >CANCELAR</b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LOS CONRATOS -->
  </div>
</template>

<script>
import moment from "moment";

const type = {
  ABONO: "ABONO",
  ACUERDO_SIMPLE: "ACUERDO_SIMPLE",
  ACUERDO_PROGRAMADO: "ACUERDO_PROGRAMADO",
};

export default {
  name: "payment",
  // props: ["_debtor_id", "_closed_debt", "debtor_status"],
  props: {
    _debtor_id: {
      type: String,
      default: null
    },
    _closed_debt: {
      type: Boolean,
      default: true
    },
    debtor_status: {
      type: String,
      default: true
    },
    _currency: {
      type: Object,
      default: {}
    }
  },
  data: () => {
    return {
      title: null,
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      minDate: null,
      maxDate: null,
      lstPayments: [],
      isEdit: false,
      disabled_status: false,
      datos: [],
      errores: [],
      lstPaidTo: [],
      isEditAgreement: false,
      disabled: false,
      debtor_id: null,
      payment: {
        type: null,
        debtor_id: null,
        date: null,
        compromise_date: null,
        pay_date: null,
        paid_to: null,
        value: null,
        status: null,
        observation: null,
        process_id: 1,
        // PARA EL ACUERDO PROGRAMADO
        start_date: null,
        end_date: null,
        loop: null,
        // PARA LA DIVISA
        currency_id: null,
        currency_value: null
      },
      _type: {},
      _type_aux: {},
      type_select: "",
      closed_debt: false,
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      // VARIABLES PARA LA PAGINACIÓN
      laravelData: {},
      limit: 5,
      showDisabled: true,
      size: "small",
      align: "right",
      customer_id: null,
      currency: null
    };
  },
  beforeMount() {
    this.closed_debt =
      this._closed_debt === undefined ? null : this._closed_debt; // PARA VERIFICAR SI LA DEUDA ESTA CERRADA
    this.debtor_id = this._debtor_id === undefined ? null : this._debtor_id;
    this._type = type;
    this._type_aux = type;
    this.currency = this._currency;
    this.enabledActions();
    this.getPayments();
  },

  methods: {
    getPayments: function (page = 1) {
      showLoader();
      let id = this.$route.params.id;
      // DETERMINAR EL NUMERO DE LA PAGINA
      // let page = darNumeroPaginaPaginacion(urlPage);

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = `${this.$urlApi}payments/debtor/${id}/${this.role_id}?token=${this.token}&page=${page}`;

      this.$http
        .get(url, this.auth, {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log();
            this.lstPayments = response.data.data.data;
            this.laravelData = response.data.data;
            // this.pagination = setPaginator(response.data.data);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },

    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    initParametersPayment() {
      this.disabled_status = false;
      this.type_select = "";

      // TIPIFICACIÓN
      this.$http.get(`${this.$urlApi}parameters/17?token=${this.token}`).then(
        (response) => {
          this.lstPaidTo = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    addPayment(_type) {
      this.initParametersPayment();
      this.errores = [];
      $("#dlgPayment").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isEditAgreement = false;
      this.file = null;
      // INICIALIZAR LOS CAMPOR DEL ACUERDO
      this.payment.type = null;
      this.payment.compromise_date = null;
      this.payment.debtor_id = this.debtor_id;
      this.payment.pay_date = null;
      this.payment.paid_to = null;
      this.payment.value = null;
      this.payment.status = "P";
      this.payment.process_id = 1;
      this.payment.observation = null;
      // PARA EL ACUERDO PROGRAMADO
      this.start_date = null;
      this.end_date = null;
      this.loop = null;
      this.disabled_status = true;
      this.type_select = _type;

      switch (_type) {
        case type.ABONO:
          this.title = "CREAR ABONO";
          this.payment.status = "F"; // PAGADO
          this.payment.type = "AB"; // ABONO
          this.minDate = null;
          this.maxDate = moment(String(new Date())).format("YYYY-MM-DD");
          break;
        case type.ACUERDO_SIMPLE:
          this.payment.type = "AC"; // ACUERDO
          this.minDate = moment(String(new Date())).format("YYYY-MM-DD");
          this.maxDate = null;
          this.title = "CREAR ACUERDO - SIMPLE";
          break;
        case type.ACUERDO_PROGRAMADO:
          this.payment.type = "AC"; // ACUERDO
          this.minDate = moment(String(new Date())).format("YYYY-MM-DD");
          this.maxDate = null;
          this.title = "CREAR ACUERDO - PROGRAMADO";
          break;
      }

      $("#dlgPayment").modal("show");
    },
    editPayment(item) {
      console.log(item);

      if (!this.isAdmin && item.status === "F") {
        this.$swal({
          title: "Advertencia",
          text: "El registro no se puede editar, ya se encuenta pagado!",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return false;
      }

      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE ELIMINAR
      if (!this.isAdmin) {
        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(item._created_at, "YYYY-MM-DD HH:mm:ss");
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if ((dias > 0 || minutos > 10) && this.UPDATE && !item.status == "P") {
          this.$swal({
            title: "Oops...",
            text:
              "El registro ya superó los 10 minutos para ser modificado, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.initParametersPayment();

      switch (item.type) {
        case "AB":
          this.title = "EDITAR ABONO";
          break;
        case "AC":
          this.title = "EDITAR ACUERDO";
          break;
      }
      this.errores = [];
      $("#dlgPayment").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      // this.payment = item;
      this.payment = Object.assign({}, item);
      this.file = null;
      this.isEditAgreement = true;
      $("#dlgPayment").modal("show");
    },
    viewPayment(item) {
      this.initParametersPayment();
      $("#dlgPayment").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      // this.payment = item;
      this.payment = Object.assign({}, item);
      this.disabled = true;
      $("#dlgPayment").modal("show");
    },
    savePayment() {
      if (this.isEditAgreement) {
        this.updatePayment();
      } else {
        this.$swal({
          title: "Guardar",
          text: "¿Está seguro que toda la información ingresada es correcta?",
          type: "question",
          showCancelButton: true,
          cancelButtonText: "Volver",
          confirmButtonText: "Si",
        }).then((result) => {
          if (result.value) {
            this.createPayment();
          }
        });
      }
    },
    createPayment() {
      showLoader();

      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.payment.url = `${location.origin}/#/debtors/view/`;
      this.payment.user_id = auth[0].id;
      this.payment.auth_is_admin = this.isAdmin;

      this.datos = JSON.stringify(this.payment);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.payment));
      formData.append("document", this.file);
      //console.log(this.datos)
      //return false

      let url =
        this.type_select == type.ACUERDO_PROGRAMADO
          ? `${this.$urlApi}payments/storeloop?token=${this.token}`
          : `${this.$urlApi}payments?token=${this.token}`;

      this.$http
        .post(url, this.datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL CONTRATO GUARDADO
              this.payment.debtor_id = null;
              this.getPayments();
              $("#dlgPayment").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    updatePayment() {
      // COMO ES UN OBJETO FormData SE DEBE ENVIAR UN POST Y CAMBIAR EL METODO A PUT, SOLO SIRVE PARA LARAVEL
      showLoader();
      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.payment.url = `${location.origin}/#/customers/view/`;
      // this.payment.user_id = auth[0].id;
      this.payment.auth_is_admin = this.isAdmin;

      this.datos = JSON.stringify(this.payment);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.payment));
      formData.append("document", this.file);
      formData.append("_method", "PUT");
      this.$http
        // .post(
        .put(
          `${this.$urlApi}payments/${this.payment.id}?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL CONTRATO GUARDADO
              this.payment.debtor_id = null;
              this.getPayments();
              $("#dlgPayment").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deletePayment(item) {
      if (!this.isAdmin && item.status === "F") {
        this.$swal({
          title: "Advertencia",
          text: "El Registro no se puede eliminar, ya se encuenta pagado!",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
        return false;
      }

      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE ELIMINAR
      if (!this.isAdmin) {
        var auth = localStorage.getItem("auth");
        auth = JSON.parse(auth);
        var user_id = auth[0].id;

        if (item.user_id != user_id) {
          this.$swal({
            title: "Advertencia",
            text:
              "El resgitro no se puede eliminar, fue creado por otro usuario!",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }

        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(item._created_at, "YYYY-MM-DD HH:mm:ss");
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "El registro ya superó los 10 minutos para ser eliminado, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar el registro ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}payments/${item.id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Registro eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getPayments();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    closePayment() {
      this.isEditAgreement = false;
      this.disabled = false;
      $("#dlgPayment").modal("hide");
    },
    onImageChange(e) {
      console.log(e.target.files[0]);
      this.file = e.target.files[0];
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    enabledActions() {
      switch (this.role_id) {
        case "1": // ADIMISTRADOR
          this.CREATE = true;
          this.READ = true;
          this.UPDATE = true;
          this.DELETE = true;
          break;

        case "2": // COMERCIAL
        case "7": // GERENTE COMERCIAL
          this.CREATE = false;
          this.READ = true;
          this.UPDATE = false;
          this.DELETE = false;
          break;

        case "4": // PREJURIDICO
        case "8": // GERENTE PREJURIDICO
        case "5":
        case "9":
          this.CREATE = true;
          this.READ = true;
          this.UPDATE = true;
          this.DELETE = true;
          break;

        case "6": // PREJURIDICO
          this.CREATE = false;
          this.READ = true;
          this.UPDATE = false;
          this.DELETE = false;
          break;

        default:
          // OTRO ROL
          this.CREATE = false;
          this.READ = false;
          this.UPDATE = false;
          this.DELETE = false;
          break;
      }

      // VALIDACIÓN DE ESTADOS
      // C: Castigado
      // D: Devuelto
      // P: Pausado
      this.CREATE =
        this.debtor_status == "C" ||
        this.debtor_status == "D" ||
        this.debtor_status == "P"
          ? false
          : this.CREATE;
    },
    calculateCurrency(){
      this.payment.currency_id = this.currency.currency_id;
      this.payment.value = this.payment.currency_value > 0 ? this.payment.currency_value * this.currency.value : 0;

    }
  },
};
</script>
